class TaskCategoryAddonPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_category_addon.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_category_addon._m';

    // Can access archived task category addons
    static ACCESS_ARCHIVE = 'task_category_addon.access.archive';

    // Can access disabled task category addons
    static ACCESS_DISABLED = 'task_category_addon.access.disabled';

    // Can create task category addons
    static CREATE = 'task_category_addon.create';

    // Can update task category addons
    static UPDATE = 'task_category_addon.update';

    // Can archive task category addon
    static ARCHIVE = 'task_category_addon.archive';

    // Can restore task category addon
    static RESTORE = 'task_category_addon.restore';

}

export default TaskCategoryAddonPermission;
